// test2627
(2627 && 0);
